<template>
  <div class="foot">
    <div class="mainContent">
      <div class="column">
        <a href="/home">
          <div>Inicio</div>
        </a>
        <a @click="onJump">
          <div>Sobre nosotros</div>
        </a>
        <a href="/help">
          <div>FAQ</div>
        </a>
        <a href="/notice">
          <div>Aviso de privacidad</div>
        </a>
        <a type="blank" href="https://www.dinerbacano.co/h5/use.html">
          <div>TÉRMINOS Y CONDICIONES</div>
        </a>
      </div>
      <div class="column">
        <div class="content">
          <div>Atención al Cliente:</div>
          <div>+57 601 580 0991</div>
        </div>
        <div class="content">
          <div>WhatsApp:</div>
          <div>3165460883</div>
        </div>
        <div class="content">
          <div>Email:</div>
          <div>servicio@dinerbacano.co</div>
        </div>
        <div class="content">
          <div>Horario de Atención:</div>
          <div>
            L-V 8:00 a 17:00<br />
            S 8:00 a 12:00
          </div>
        </div>
      </div>
      <div class="column columnImgLast">
        <div>Descargar</div>
        <a
          target="blank"
          href="https://play.google.com/store/apps/details?id=cash.money.loan.coin.dinerbacano"
        >
          <img src="../assets/image/playBtn.webp" alt="" />
        </a>
        <div style="margin-top:20px">Síguenos</div>
        <div class="siguenos_img">
          <a href="https://www.facebook.com/profile.php?id=100094369292301">
            <img src="../assets/image/siguenos_one.webp" />
          </a>
          <a
            href="https://www.instagram.com/dinerbacano_oficial_/?igshid=YTQwZjQ0NmI0OA%3D%3D"
          >
            <img src="../assets/image/siguenos_two.webp" />
          </a>
          <a href="https://www.tiktok.com/@dinerbacano_oficial">
            <img src="../assets/image/siguenos_three.webp" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/foot.scss";
export default {
  name: "footPage",
  data() {
    return {
      value: 1,
    };
  },
  methods: {
    onJump() {
      this.value++;
      this.$router.push(`/home?value=${this.value}`);
    },
  },
};
</script>
